import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { injectIntl, intlShape } from 'react-intl';
import { Back, Next, ChatToAFitter } from '../ControlButtons';
import { SizeQuizExampleButton, SizeQuizButton } from '../selects/Buttons';
import { dataLayerGA4SizeQuizStageNumber } from '../../../shared/utils/data-layer';

const Stage8 = ({
  buttonSelected,
  cachedCupSize,
  cupChange,
  cupSize,
  defaultButtonProps,
  defaultNextProps,
  defaultPreviousProps,
  intl: { formatMessage },
  messages,
  resetCup,
  setTempCupCache,
  stage8Data,
}) => {
  const STAGE_NUMBER = '8';

  useEffect(() => {
    window.scrollTo(0, 0);
    dataLayerGA4SizeQuizStageNumber(STAGE_NUMBER);
  }, []);

  return (
    <div className="stageContainer">
      <div className="standardQuestionContainer">
        <Back
          {...defaultPreviousProps(2, formatMessage(messages.restartCupSize))}
          customFunc={() => {
            resetCup(cachedCupSize);
            setTempCupCache({
              cupSize: cachedCupSize,
              cupChange: 0,
            });
          }}
        />
        <div className="stage stage-9">
          <div className="wrap wrap--left">
            <h4>{formatMessage(messages.stage8para1)}</h4>
            <SizeQuizExampleButton
              className="stage__tooltipBtn"
              message={formatMessage(messages.example)}
            />
            <div className="buttonsContainer">
              {stage8Data.map(({ func, text }, idx) => (
                <SizeQuizButton
                  key={idx}
                  {...defaultButtonProps(text, idx, func)}
                />
              ))}
            </div>
            <div>
              <Next
                hasChevron
                disabled={!buttonSelected}
                {...defaultNextProps(1, 'Next question')}
                customFunc={() => {
                  setTempCupCache({
                    cupSize: cupSize,
                    cupChange: cupChange,
                  });
                }}
              />
            </div>
          </div>
        </div>
      </div>
      <hr className="contentDivider" />
      <div id="fittersAdvice" className="contentContainer">
        <h4 className="contentHeader">
          {formatMessage(messages.adviceFromABraFitterHeader)}
        </h4>
        <picture className="c-picture">
          <source
            srcSet="//images.ctfassets.net/bz0fvtkbk5r1/1za2qikaEnnIn9kT63fAg8/adc71ebce1ef178461c6d89f0569a1e6/Wires-digging-in.jpg?q=80&amp;w=868&amp;fm=webp"
            type="image/webp"
          />
          <img
            alt="Why does the underwire in my bra hurt?"
            src="//images.ctfassets.net/bz0fvtkbk5r1/1za2qikaEnnIn9kT63fAg8/adc71ebce1ef178461c6d89f0569a1e6/Wires-digging-in.jpg?q=80&amp;w=868"
            className="c-image"
          />
        </picture>
        <p className="contentSubHeader">
          {formatMessage(messages.stage8para2)}
        </p>
        <ChatToAFitter stage={STAGE_NUMBER} />
      </div>
    </div>
  );
};

export default injectIntl(Stage8);

Stage8.propTypes = {
  Back: PropTypes.func,
  SizeQuizButton: PropTypes.func,
  buttonSelected: PropTypes.number,
  cachedCupSize: PropTypes.string,
  cupChange: PropTypes.number,
  cupSize: PropTypes.string,
  defaultButtonProps: PropTypes.func,
  defaultNextProps: PropTypes.func,
  defaultPreviousProps: PropTypes.func,
  SizeQuizExampleButton: PropTypes.func,
  intl: intlShape,
  messages: PropTypes.object,
  Next: PropTypes.func,
  resetCup: PropTypes.func,
  setTempCupCache: PropTypes.func,
  stage8Data: PropTypes.array,
  tooltip: PropTypes.object,
};
